import React from "react";
import "./AboutUs.css";

// React-icons
import { FaMapMarked } from "react-icons/fa";
import { FaRegFaceSmile } from "react-icons/fa6";
import { MdConstruction } from "react-icons/md";
import { MdEngineering } from "react-icons/md";
import { FaMoneyBillWave } from "react-icons/fa";
import { FaToolbox } from "react-icons/fa";
import { IoGiftSharp } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";

import portfolio from "../Home/imgs/portfolio_3.jpg";

// Initialization for ES Users
import { Carousel, initTWE } from "tw-elements";

//Imported Images
import img1 from "../AboutUs/imgs/img_1.jpg";
import img2 from "../AboutUs/imgs/img_2.jpg";
import img3 from "../AboutUs/imgs/img_3.jpg";
import img4 from "../AboutUs/imgs/img_4.jpg";
import img5 from "../AboutUs/imgs/img_5.jpg";
import img6 from "../AboutUs/imgs/img_6.jpg";
import img7 from "../AboutUs/imgs/img_7.jpg";
import img8 from "../AboutUs/imgs/img_8.jpg";
import img9 from "../AboutUs/imgs/img_9.jpg";
import img10 from "../AboutUs/imgs/img_10.jpg";
import img11 from "../AboutUs/imgs/img_11.jpg";
import img12 from "../AboutUs/imgs/img_12.jpg";
import img13 from "../AboutUs/imgs/img_13.jpg";
import img14 from "../AboutUs/imgs/img_14.jpg";
import img15 from "../AboutUs/imgs/img_15.jpg";
import img16 from "../AboutUs/imgs/img_16.jpg";
import img17 from "../AboutUs/imgs/img_17.jpg";
import img18 from "../AboutUs/imgs/img_18.jpg";
import img19 from "../AboutUs/imgs/img_19.jpg";
import img20 from "../AboutUs/imgs/img_20.jpg";
import img21 from "../AboutUs/imgs/img_21.jpg";
import img22 from "../AboutUs/imgs/img_22.jpg";
import img23 from "../AboutUs/imgs/img_23.jpg";
import img24 from "../AboutUs/imgs/img_24.jpg";
import img25 from "../AboutUs/imgs/img_25.jpg";
import img26 from "../AboutUs/imgs/img_26.jpg";
import img27 from "../AboutUs/imgs/img_27.jpg";
import img28 from "../AboutUs/imgs/img_28.jpg";

initTWE({ Carousel });

const AboutUs = () => {
  const sliderImage = [
    {
      id: 1,
      img: img1,
    },
    {
      id: 2,
      img: img2,
    },
    {
      id: 3,
      img: img3,
    },
    {
      id: 4,
      img: img4,
    },
    {
      id: 5,
      img: img5,
    },
    {
      id: 6,
      img: img6,
    },
    {
      id: 7,
      img: img7,
    },
    {
      id: 8,
      img: img8,
    },
    {
      id: 9,
      img: img9,
    },
    {
      id: 10,
      img: img10,
    },
    {
      id: 11,
      img: img11,
    },
    {
      id: 12,
      img: img12,
    },
    {
      id: 13,
      img: img13,
    },
    {
      id: 14,
      img: img14,
    },
    {
      id: 15,
      img: img15,
    },
    {
      id: 16,
      img: img16,
    },
    {
      id: 17,
      img: img17,
    },
    {
      id: 18,
      img: img18,
    },
    {
      id: 19,
      img: img19,
    },
    {
      id: 20,
      img: img20,
    },
    {
      id: 21,
      img: img21,
    },
    {
      id: 22,
      img: img22,
    },
    {
      id: 23,
      img: img23,
    },
    {
      id: 24,
      img: img24,
    },
    {
      id: 25,
      img: img25,
    },
    {
      id: 26,
      img: img26,
    },
    {
      id: 27,
      img: img27,
    },
    {
      id: 28,
      img: img28,
    },
  ];

  return (
    <>
      <section class="">
        <div class="py-12 bg-white">
          <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="font-semibold text-xl mb-4 bg-orange-100 text-orange-800 px-4 py-2 rounded-lg md:w-64 md:mx-auto tracking-widest text-black uppercase title-font">
                لماذا تختارنا؟
              </h2>

              {/* تحسين استجابة الصورة */}
              <div className="flex justify-center">
                <img
                  className="w-44 max-w-xs sm:w-40 md:max-w-md lg:max-w-lg xl:max-w-xl h-auto rounded-full mt-2"
                  style={{ boxShadow: "0 0px 10px #111" }}
                  src={portfolio}
                  alt="portfolio"
                />
              </div>

              <p className="font-heading mt-2 text-3xl leading-8 font-semibold tracking-tight text-gray-900 sm:text-4xl">
                نحن خبراء في مجال المقاولات والبناء. نضمن جودة عالية وسرعة
                تنفيذ.
              </p>
              <p className="mt-4 max-w-2xl text-lg text-gray-500 lg:mx-auto">
                نحن ندير جميع جوانب المشروع، من التخطيط إلى التنفيذ، ونضمن رضا
                العملاء الكامل.
              </p>
            </div>

            <div class="mt-10">
              <dl class="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                <div class="relative">
                  <dt>
                    <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500">
                      <MdConstruction className="text-4xl text-rose-600" />
                    </div>
                    <p class="font-heading  relative right-12 ml-16 text-lg leading-6 font-bold text-gray-700">
                      معدات حديثة
                    </p>
                  </dt>
                  <dd class="mt-2 ml-16  relative right-12 text-base text-gray-500">
                    نستخدم أحدث المعدات والتقنيات لضمان تنفيذ المشروع بأعلى
                    معايير الجودة.
                  </dd>
                </div>
                <div class="relative">
                  <dt>
                    <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500">
                      <MdEngineering className="text-4xl text-rose-600" />
                    </div>
                    <p class="font-heading relative right-12 ml-16 text-lg leading-6 font-bold text-gray-700">
                      فريق متخصص
                    </p>
                  </dt>
                  <dd class="mt-2 ml-16 relative right-12 text-base text-gray-500">
                    فريقنا من المهندسين والفنيين ذوي الخبرة يضمنون تنفيذ المشروع
                    بكل دقة وكفاءة.
                  </dd>
                </div>
                <div class="relative">
                  <dt>
                    <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500">
                      <FaMoneyBillWave className="text-4xl text-rose-600" />
                    </div>
                    <p class="font-heading relative right-12 ml-16 text-lg leading-6 font-bold text-gray-700">
                      تكلفة معقولة
                    </p>
                  </dt>
                  <dd class="mt-2 ml-16 relative right-12 text-base text-gray-500">
                    نقدم أسعاراً تنافسية دون المساومة على جودة العمل.
                  </dd>
                </div>
                <div class="relative">
                  <dt>
                    <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-500">
                      <FaToolbox className="text-4xl text-rose-600" />
                    </div>
                    <p class="font-heading relative right-12 ml-16 text-lg leading-6 font-bold text-gray-700">
                      دعم مستمر
                    </p>
                  </dt>
                  <dd class="mt-2 ml-16 relative right-12 text-base text-gray-500">
                    نقدم دعم مستمر خلال جميع مراحل المشروع لضمان سير العمل
                    بسلاسة.
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>

      <section class="text-gray-950 font-bold body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap text-center justify-center">
            <div class="p-4 md:w-1/4 sm:w-1/2">
              <div class="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div class="flex justify-center">
                  <img
                    src="https://image2.jdomni.in/banner/13062021/3E/57/E8/1D6E23DD7E12571705CAC761E7_1623567977295.png?output-format=webp"
                    class="w-32 mb-3"
                  />
                </div>
                <h2 class="title-font font-regular text-2xl text-gray-900">
                  أقل وأفضل أسعار وخصم 7% بمناسبة مرور "7" عام من الخبرة
                </h2>
              </div>
            </div>

            <div class="p-4 md:w-1/4 sm:w-1/2">
              <div class="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div class="flex justify-center">
                  <img
                    src="https://image3.jdomni.in/banner/13062021/16/7E/7E/5A9920439E52EF309F27B43EEB_1623568010437.png?output-format=webp"
                    class="w-32 mb-3"
                  />
                </div>
                <h2 class="title-font font-regular text-2xl text-gray-900">
                  كفاءة الوقت وأسرع خدمة
                </h2>
              </div>
            </div>

            <div class="p-4 md:w-1/4 sm:w-1/2">
              <div class="px-4 py-6 transform transition duration-500 hover:scale-110">
                <div class="flex justify-center">
                  <img
                    src="https://image3.jdomni.in/banner/13062021/EB/99/EE/8B46027500E987A5142ECC1CE1_1623567959360.png?output-format=webp"
                    class="w-32 mb-3"
                  />
                </div>
                <h2 class="title-font font-regular text-2xl text-gray-900">
                  عملاء متخصصون و ذو خبرة عالية في المجال
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mb-28">
        <div className="title relative text-center mb-16 text-4xl font-bold">
          <h1>أعمالنا السابقة</h1>
          <p className="w-56 mt-2 h-1 rounded-sm top-5 bg-rose-600 mx-auto"></p>
        </div>
        <div className="slider max-w-screen-xl mx-auto px-4">
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
            }}
            loop={true}>
            {sliderImage.map((image) => (
              <SwiperSlide>
                <img
                  src={image.img}
                  alt="..."
                  className="w-full h-auto rounded-md shadow-2xl bg-[#00000035] p-3"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      <section class="m-4 md:m-8 bg-gray-50 text-gray-950">
        <div class="container mx-auto p-4 my-6 space-y-2 text-center">
          <h2 class="text-4xl text-center font-bold">دع الأرقام تتكلم</h2>
          <div class="flex justify-center">
            <p class="w-[100px] h-[4px] rounded-sm bg-rose-600 mt-2"></p>
          </div>
        </div>
        <div class="container mx-auto grid gap-4 sm:grid-cols-2 lg:grid-cols-3 justify-center">
          <div class="flex flex-col items-center p-4">
            <IoGiftSharp class="text-6xl text-rose-600" />
            <h3 class="my-3 text-3xl font-bold">7%</h3>
            <div class="space-y-1 leading-tight text-center">
              <h2 class="text-2xl">خصم 7% بمناسبة مرور 7 أعوام من الخبرة</h2>
            </div>
          </div>
          <div class="flex flex-col items-center p-4">
            <FaRegFaceSmile class="text-6xl text-rose-600" />
            <h3 class="my-3 text-3xl font-bold">
              <strong>+</strong>220
            </h3>
            <div class="space-y-1 leading-tight text-center">
              <h2 class="text-2xl">العملاء</h2>
            </div>
          </div>
          <div class="flex flex-col items-center p-4">
            <FaMapMarked class="text-6xl text-rose-600" />
            <h3 class="my-3 text-3xl font-bold">2</h3>
            <div class="space-y-1 leading-tight text-center">
              <h2 class="text-2xl">الأفرع</h2>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
